module.exports = __webpack_public_path__ + "img/Y6.5358c34b.png";